module.exports = __webpack_public_path__ + "static/media/AppStore.5c856e0e.svg";